<template>
  <div id="app">
    <router-view />
    
    <!-- Scroll to Top Button -->
    <button
      ref="scrollTopButton"
      @click="scrollToTop"
      class="fixed bottom-8 right-8 z-50 flex items-center justify-center w-12 h-12 bg-slate-custom hover:bg-slate-900 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 group opacity-0 translate-y-10 pointer-events-none"
      aria-label="Scroll to top"
    >
      <span class="material-symbols-outlined text-xl">keyboard_arrow_up</span>
    </button>
  </div>
</template>


<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const scrollTopButton = ref(null)

const handleScroll = () => {
  if (scrollTopButton.value) {
    const show = window.scrollY > 300
    scrollTopButton.value.classList.toggle("opacity-0", !show)
    scrollTopButton.value.classList.toggle("translate-y-10", !show)
    scrollTopButton.value.classList.toggle("pointer-events-none", !show)
    scrollTopButton.value.classList.toggle("opacity-100", show)
    scrollTopButton.value.classList.toggle("translate-y-0", show)
    scrollTopButton.value.classList.toggle("pointer-events-auto", show)
  }
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
/* Additional styles if needed */
</style>
